<section class="envio-simple-stepper-card">
<ol class="simple-stepper" aria-label="Progreso envío simple">
  <ng-container *ngFor="let step of elementos; let i = index; let last = last">
    <li class="simple-stepper__item" [ngClass]="getItemClass(i)">
      <div class="dots" [ngClass]="getDotClass(i)">
        <span *ngIf="!isComplete(i)" class="white-dot"></span>
        <span *ngIf="isComplete(i)">
          <svg class="icon-tick">
            <use xlink:href="#hs-tick2"></use>
          </svg>
        </span>
      </div>
      <span class="simple-stepper__label">{{ step }}</span>
    </li>
    <li *ngIf="!last" class="simple-stepper__connector" [ngClass]="getLineClass(i)" aria-hidden="true"></li>
  </ng-container>
</ol>
</section>